import { Button, CircularProgress, Paper, TextField, Box, Tab, Tabs, Typography } from '@material-ui/core';
import { createPost, deletePost, getPostsByPage, getPostsBySearch, updatePost } from "../../actions/posts"
import ES from "../../img/espana.png"
import EN from "../../img/reino-unido.png"
import rss1 from "../../img/rss1.PNG"
import rss2 from "../../img/rss2.PNG"
import rss3 from "../../img/rss3.PNG"
import LockIcon from '@material-ui/icons/Lock';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Select from 'react-select'
import Checkbox from '@material-ui/core/Checkbox';
import PropTypes from 'prop-types';
import { useLocation, Link } from "react-router-dom"
import RefreshIcon from '@material-ui/icons/Refresh';
import SearchIcon from '@material-ui/icons/Search';
import ChipInput from "material-ui-chip-input"
import VisibilityIcon from '@material-ui/icons/Visibility';
import useStyles from "./styles"
import Pagination from "../Practice/Pagination"
import React, { useEffect, useState } from 'react'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import PeopleIcon from '@material-ui/icons/People';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import { Animate } from "react-simple-animate";
import Lang from "../../Lang"
import { fetchFeed } from '../../api';

function useQuery() {
    return new URLSearchParams(useLocation().search)
}

function Lista(navigation) {

    const classes = useStyles()
    const user = JSON.parse(localStorage.getItem("profile"))
    const userId = user?.result?.googleId || user?.result?.userId
    const dispatch = useDispatch()
    const posts = useSelector((state) => state.posts)
    const [postData, setPostData] = useState({ title: "", value: "", tags: ["General"], users: [{ userId: userId, userName: user?.result.name }], popular: 0, lang: "" })
    const [probarPosts, setProbarPosts] = useState([])
    const array = []
    let scores = useSelector((state) => state.scores)


    const query = useQuery()
    let page = query.get("page") || 1
    const [limit, setLimit] = useState(3)
    const searchQuery = query.get("searchQuery")
    const [tags, setTags] = useState([])
    const [search, setSearch] = useState("")
    const [rss, setRss] = useState("")
    !localStorage.getItem("lang") && localStorage.setItem("lang", "ES")
    const language = localStorage.getItem("lang")
    const [lang, setLang] = useState([language.toUpperCase()])
    const [langCheck, setLangCheck] = useState({ ES: language.toUpperCase() === "ES", EN: language.toUpperCase() === "EN" })
    const [anadir, setAnadir] = useState(false)
    const [probando, setProbando] = useState(false)
    const [ayuda, setAyuda] = useState(false)
    const [openRss, setOpenRss] = useState(false)
    const [showPost, setShowPost] = useState(false)

    const [message, setMessage] = useState("initialValue")

    const notify = () => toast.info(<><Lang props={"Has alcanzado tu límite!"} /><Button component={Link} to={user ? "/Preferences" : "Auth"}><VisibilityIcon className={classes.visibility_icon} /></Button></>, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
    })

    useEffect(() => {
        message !== "initialValue" && notify()
    }, [message])

    const getText = async (u) => {
        let feed = await fetchFeed(u)
        setProbando(false)
        feed.data.items.forEach(item => {
            array.push(item.title)
            if (feed.data.items.length === array.length) { setProbarPosts(array) }
        });
    }

    useEffect(() => {
        searchPost()
    }, [page])

    useEffect(() => {
        page = 1
        dispatch(getPostsByPage({ page, limit, userId, lang }))
    }, [limit])

    useEffect(() => {
        searchPost()
    }, [tags, postData.tags, lang])

    useEffect(() => {
        setOpenRss(false)
        if (navigation.navigation == 0) {
            setSearch("")
            setTags([])
            setRss("")
            setAnadir(false)
            dispatch(getPostsByPage({ page, limit, userId, lang }))  /// optimizar en reducer?
        }
        if (navigation.navigation == 1) {
            setAnadir(false)
            dispatch(getPostsByPage({ page, limit, userId, lang }))
        }
        if (navigation.navigation == 2) {
            probarOtro()
        }
    }, [navigation.navigation])

    // - Check si label está en mi cuenta

    const testText = () => {
        setProbando(true)
        getText(postData.value)
        setTimeout(() => {
            setProbando(false)
        }, 2000);
    }

    const probarOtro = () => {
        setProbarPosts([])
    }

    const anadirPost = (itemId, users) => {
        setShowPost(itemId)
        setTimeout(() => {
            setShowPost(false)
        }, 300);
        dispatch(updatePost(itemId, { users: users, userId: userId, userName: user.result.name, search, rss, tags: tags.join(","), lang: lang.join(","), limit, page }, message, setMessage))
    }

    const searchPost = () => {
        if (rss.trim() || search.trim() || tags.length !== 0) {
            dispatch(getPostsBySearch({ search, rss, tags: tags.join(","), lang: lang.join(","), limit, page }))
        } else {
            dispatch(getPostsByPage({ page, limit, userId, lang }))
        }
    }

    const handleSubmit = (e) => {
        if (e) { e.preventDefault() }
        dispatch(createPost({ ...postData }))
        probarOtro()
        setPostData({ title: "", value: "", tags: ["General"], users: [{ userId: userId, userName: user.result.name }] })
        dispatch(getPostsByPage({ page, limit, userId, lang }))
    }

    const handleKeyPress = () => {
        searchPost()
    }

    const handleCheckbox = (e) => {
        switch (e.target.name) {
            case "ES":
                setLangCheck({ ES: !langCheck.ES, EN: langCheck.EN })
                break;

            case "EN":
                setLangCheck({ ES: langCheck.ES, EN: !langCheck.EN })
                break;
            default:
                break;
        }

        if (lang.includes(e.target.name)) {
            let x = [...lang]
            x.filter(lang => lang === e.target.name)
            setLang(x)
        } else {
            let x = [...lang]
            x.push(e.target.name)
            setLang(x)
        }
    }

    const handleLangSelect = (e) => {
        setPostData({ ...postData, lang: e.value })
    }

    useEffect(() => {
        let tempLang = []
        langCheck.ES && tempLang.push("ES")
        langCheck.EN && tempLang.push("EN")
        setLang(tempLang)
    }, [langCheck])

    const uploadReady = (tag) => {
        const map = {
            '-': ' ',
            '-': '_',
            'a': 'á|à|ã|â|ä|À|Á|Ã|Â|Ä',
            'e': 'é|è|ê|ë|É|È|Ê|Ë',
            'i': 'í|ì|î|ï|Í|Ì|Î|Ï',
            'o': 'ó|ò|ô|õ|ö|Ó|Ò|Ô|Õ|Ö',
            'u': 'ú|ù|û|ü|Ú|Ù|Û|Ü',
            'c': 'ç|Ç',
            '': '´'
        };

        for (var pattern in map) {
            tag = tag.replace(new RegExp(map[pattern], 'g'), pattern);
        }
        tag = tag.toLowerCase()
        tag = tag.charAt(0).toUpperCase() + tag.slice(1)
        return tag;
    }

    const resetSearch = () => {
        setTags([])
        setSearch("")
        setRss("")
        setLang([language.toUpperCase()])
        setLangCheck({ ES: language.toUpperCase() === "ES", EN: language.toUpperCase() === "EN" })
        dispatch(getPostsByPage({ page, limit, userId, lang }))
    }

    const toggleAnadir = () => {
        setProbando(false)
        setProbarPosts([])
        setAnadir(!anadir)
    }

    const toggleAyuda = () => {
        setAyuda(!ayuda)
    }
    // Select ayuda
    function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box p={3}>
                        <Typography>{children}</Typography>
                    </Box>
                )}
            </div>
        );
    }

    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.any.isRequired,
        value: PropTypes.any.isRequired,
    };
    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    }

    // - Select ayuda

    const toggleOpenRss = (key, rss) => {
        setProbando(true)
        getText(rss)
        if (key === openRss) {
            setOpenRss(false)
        } else {
            setOpenRss(key)
        }
    }

    if (navigation.navigation == 0) {
        return (
            <div>
                <ToastContainer />
                {
                    !posts.myPosts.length ?
                        <div>
                            <h2><Lang props={"¡No tienes cartas!"} /></h2>
                        </div>
                        :
                        <div className={classes.paper_container}>

                            {posts.myPosts.map((item, key) => {
                                return (
                                    <Animate
                                        duration={0.15}
                                        play={showPost === item._id}
                                        start={{
                                            transform: "translateX(0px)", opacity: 1
                                        }}
                                        end={{ transform: "translateX(30px)", opacity: 0 }}
                                    >
                                        <Paper className={classes.rss_paper} key={item._id} elevation={6}>
                                            {openRss === key ?
                                                <>
                                                    <div className={classes.post_row}>
                                                        {user ?
                                                            <>
                                                                {!item.users.find(element => element.userId === userId) ?
                                                                    <Button onClick={() => anadirPost(item._id, item.users)} className={classes.add_button_container}><RadioButtonUncheckedIcon className={classes.add} /></Button>
                                                                    :
                                                                    <Button onClick={() => anadirPost(item._id, item.users)} className={classes.add_button_container}><CheckCircleOutlineIcon className={classes.add} /></Button>}
                                                            </>
                                                            : <Button component={Link} to="/auth" className={classes.add_button_container}><RadioButtonUncheckedIcon className={classes.add} /></Button>}
                                                        <Button onClick={() => toggleOpenRss(key)}><h2 className={classes.post_title}>{item.title}</h2></Button>
                                                        <Button href={item.value} target="_blank"><VisibilityIcon /></Button>
                                                    </div>
                                                    <div className={classes.post_new_row}>
                                                        <span className={classes.post_new_tag}>{item.tags.length}<LocalOfferIcon className={classes.tag_icon} /><div className={classes.post_new_tag_content}>{item.tags.map(tag => { return (<button className={classes.post_tag_button}>{tag}</button>) })}</div></span>
                                                    </div>
                                                    <div className={classes.post_row}>
                                                        <p className={classes.post_users}>{item.users.length}<PeopleIcon className={classes.people_icon} /><img src={item.lang === "ES" ? ES : EN} className={classes.lang_icon} /><div className={classes.post_new_users_content}>{item.users.map(user => { return (<button className={classes.post_users_button}>{user.userName}</button>) })}</div></p>
                                                    </div>
                                                    <div className={classes.post_news_row}>
                                                        <h2><Lang props={"Últimas noticias subidas:"} /></h2>
                                                        {

                                                            !probando ?
                                                                probarPosts.slice(0, 5).map(item => {
                                                                    return (

                                                                        <Paper className={classes.example_news} elevation={3}>
                                                                            <span>{item}</span>
                                                                        </Paper>)
                                                                })
                                                                :
                                                                <CircularProgress />
                                                        }
                                                    </div>
                                                </>
                                                :
                                                <>
                                                    <div className={classes.post_row}>
                                                        {user ?
                                                            <>
                                                                {!item.users.find(element => element.userId === userId) ?
                                                                    <Button onClick={() => anadirPost(item._id, item.users)} className={classes.add_button_container}><RadioButtonUncheckedIcon className={classes.add} /></Button>
                                                                    :
                                                                    <Button onClick={() => anadirPost(item._id, item.users)} className={classes.add_button_container}><CheckCircleOutlineIcon className={classes.add} /></Button>}
                                                            </>
                                                            : <Button component={Link} to="/auth" className={classes.add_button_container}><RadioButtonUncheckedIcon className={classes.add} /></Button>}
                                                        <Button onClick={() => toggleOpenRss(key, item.value)}><h2 className={classes.post_title}>{item.title}</h2></Button>
                                                    </div>
                                                    <span className={classes.post_tag}>{item.tags.length}<LocalOfferIcon className={classes.tag_icon} /><div className={classes.post_tag_content}>{item.tags.map(tag => { return (<button className={classes.post_tag_button}>{tag}</button>) })}</div></span>
                                                    <div className={classes.post_row}>
                                                        <p className={classes.post_users}>{item.users.length}<PeopleIcon className={classes.people_icon} /><img src={item.lang === "ES" ? ES : EN} className={classes.lang_icon} /><div className={classes.post_users_content}>{item.users.map(user => { return (<button className={classes.post_users_button}>{user.userName}</button>) })}</div></p>
                                                    </div>
                                                </>
                                            }
                                        </Paper>
                                    </Animate>)
                            })}

                        </div>
                }
            </div>
        )

    } else if (navigation.navigation == 1) {
        return (
            <div>
                <ToastContainer />
                {
                    !posts.popularPosts ?
                        <div>
                            <p><Lang props={"No hay nada O.O"} /></p>
                        </div>
                        :
                        (
                            <div className={classes.paper_container}>

                                {
                                    posts.popularPosts.map((item, key) => {
                                        return (<Animate
                                            duration={0.15}
                                            play={showPost === item._id} // Toggle when animation should start
                                            start={{
                                                transform: "translateX(0px)", opacity: 1
                                            }}
                                            end={{ transform: "translateX(40px)", opacity: 0.1 }}
                                        >
                                            <Paper className={classes.rss_paper} key={item._id} elevation={6}>
                                                {openRss === key ?
                                                    <>
                                                        <div className={classes.post_row}>
                                                            <h2>{key + 1}º</h2>
                                                            {user ?
                                                                <>
                                                                    {!item.users.find(element => element.userId === userId) ?
                                                                        <Button onClick={() => anadirPost(item._id, item.users)} className={classes.add_button_container}><RadioButtonUncheckedIcon className={classes.add} /></Button>
                                                                        :
                                                                        <Button onClick={() => anadirPost(item._id, item.users)} className={classes.add_button_container}><CheckCircleOutlineIcon className={classes.add} /></Button>}
                                                                </>
                                                                : <Button component={Link} to="/auth" className={classes.add_button_container}><RadioButtonUncheckedIcon className={classes.add} /></Button>}
                                                            <Button onClick={() => toggleOpenRss(key)}><h2 className={classes.post_title}>{item.title}</h2></Button>
                                                            <Button href={item.value} target="_blank"><VisibilityIcon disabled={probarPosts.length} /></Button>
                                                        </div>
                                                        <div className={classes.post_new_row}>
                                                            <span className={classes.post_new_tag}>{item.tags.length}<LocalOfferIcon className={classes.tag_icon} /><div className={classes.post_new_tag_content}>{item.tags.map(tag => { return (<button className={classes.post_tag_button}>{tag}</button>) })}</div></span>
                                                        </div>
                                                        <div className={classes.post_row}>
                                                            <p className={classes.post_users}>{item.users.length}<PeopleIcon className={classes.people_icon} /><img src={item.lang === "ES" ? ES : EN} className={classes.lang_icon} /><div className={classes.post_new_users_content}>{item.users.map(user => { return (<button className={classes.post_users_button}>{user.userName}</button>) })}</div></p>
                                                        </div>
                                                        <div className={classes.post_news_row}>
                                                            <h2><Lang props={"Últimas noticias subidas:"} /></h2>
                                                            {

                                                                !probando ?
                                                                    probarPosts.slice(0, 5).map(item => {
                                                                        return (
                                                                            <Paper className={classes.example_news} elevation={3}>
                                                                                <span>{item}</span>
                                                                            </Paper>)
                                                                    })
                                                                    :
                                                                    <CircularProgress />
                                                            }
                                                        </div>
                                                    </>
                                                    :
                                                    <>
                                                        <div className={classes.post_row}>
                                                            <h2>{key + 1}º</h2>
                                                            {user ?
                                                                <>
                                                                    {!item.users.find(element => element.userId === userId) ?
                                                                        <Button onClick={() => anadirPost(item._id, item.users)} className={classes.add_button_container}><RadioButtonUncheckedIcon className={classes.add} /></Button>
                                                                        :
                                                                        <Button onClick={() => anadirPost(item._id, item.users)} className={classes.add_button_container}><CheckCircleOutlineIcon className={classes.add} /></Button>}
                                                                </>
                                                                : <Button component={Link} to="/auth" className={classes.add_button_container}><RadioButtonUncheckedIcon className={classes.add} /></Button>}
                                                            <Button onClick={() => toggleOpenRss(key, item.value)}><h2 className={classes.post_title}>{item.title}</h2></Button>
                                                        </div>
                                                        <span className={classes.post_tag}>{item.tags.length}<LocalOfferIcon className={classes.tag_icon} /><div className={classes.post_tag_content}>{item.tags.map(tag => { return (<button className={classes.post_tag_button}>{tag}</button>) })}</div></span>
                                                        <div className={classes.post_row}>
                                                            <p className={classes.post_users}>{item.users.length}<PeopleIcon className={classes.people_icon} /><img src={item.lang === "ES" ? ES : EN} className={classes.lang_icon} /><div className={classes.post_users_content}>{item.users.map(user => { return (<button className={classes.post_users_button}>{user.userName}</button>) })}</div></p>
                                                        </div>
                                                    </>
                                                }
                                            </Paper></Animate>)
                                    })}
                            </div>
                        )
                }
            </div>
        )
    } else if (navigation.navigation == 2) {
        return (
            <div className={classes.navigation2}>
                <ToastContainer />
                {!anadir ?
                    <div className={classes.pagination}>
                        {(!searchQuery) && (
                            <Paper elevation={6} className={classes.pagination_paper} elevation={6}>
                                <Pagination page={page} limit={limit} setLimit={setLimit} />
                                <Paper className={classes.search_bar} position="static" color="inherit" elevation="3">
                                    <div>
                                        <Button className={classes.search_button} onClick={searchPost} color="primary" variant="contained"><SearchIcon /></Button>
                                        <Button className={classes.search_button} onClick={resetSearch} color="primary" variant="contained"><RefreshIcon /></Button>
                                        {scores?.myScores?.userStatus > 0 && user ?
                                            <Button onClick={() => toggleAnadir()}>{anadir ? <Lang props={"Volver"} /> : <><Lang props={"Crear carta"} /><NoteAddIcon color="primary" /></>} </Button>
                                            :
                                            <div className={classes.locked_anadir}>
                                                <Button onClick={notify}>{anadir ? <Lang props={"Volver"} /> : <><Lang props={"Crear carta"} /><NoteAddIcon /></>} </Button>
                                                <LockIcon />
                                            </div>}
                                    </div>
                                    <TextField className={classes.search_text} name="search" variant="outlined" label={<Lang props={"Nombre"} />} onKeyPress={handleKeyPress} fullWidth value={search} onChange={(e) => setSearch(e.target.value)} />
                                    <ChipInput className={classes.search_tag} name="search" variant="outlined" label={<Lang props={"Tags"} />} value={tags} onAdd={(chip) => setTags([...tags, uploadReady(chip)])} onDelete={(chip) => setTags(tags.filter((tag) => tag !== chip))} />
                                    <TextField className={classes.search_rss} name="search" variant="outlined" label={<Lang props={"RSS (link)"} />} onKeyPress={handleKeyPress} fullWidth value={rss} onChange={(e) => setRss(e.target.value)} />
                                    <div>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={langCheck.ES}
                                                    onChange={handleCheckbox}
                                                    name="ES"
                                                    color="primary"
                                                />
                                            }
                                            label="Español"
                                        />
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={langCheck.EN}
                                                    onChange={handleCheckbox}
                                                    name="EN"
                                                    color="primary"
                                                />
                                            }
                                            label="English"
                                        />
                                    </div>
                                </Paper>
                            </Paper>
                        )}
                    </div>
                    :
                    <div className={classes.anadir}>
                        <form onSubmit={handleSubmit}>
                            <Paper className={classes.paper_form} elevation={6}>
                                <h3><Lang props={"¡Aquí puedes crear cartas que no estén en mecanews!"} /></h3>
                                <Lang props={"Si solo quieres añadir otra que ya exista, busca en la sección de explorar"} />
                                <br /><br /><br />
                                <div className={classes.form_row}>
                                    {probarPosts.length ?
                                        <div>
                                            <p className={classes.aviso_correcto}><Lang props={"Funciona! Quieres añadirlo?"} /></p>
                                            <Button color="primary" type="submit" variant="contained"><Lang props={"Si!"} /></Button>
                                            <Button color="secondary" variant="contained" onClick={() => probarOtro()}><Lang props={"No, probar otro"} /></Button>
                                        </div>
                                        :
                                        <div>
                                            <Button variant="outlined" onClick={() => toggleAyuda()}>
                                                <HelpOutlineIcon />
                                            </Button>
                                            <Button color="primary" className={classes.probar_rss} variant="contained" onClick={() => testText()} disabled={!postData.value || !postData.title || !postData.tags.length || !postData.lang}>Probar RSS</Button>
                                            {!probando && <span className={classes.aviso_incorrecto}><Lang props={"De momento el enlace no es correcto..."} /></span>}
                                            {probando && <><Lang props={"Probando..."} /><CircularProgress /></>}
                                        </div>
                                    }
                                </div>
                                <div className={classes.form_row}>
                                    <TextField className={classes.form_name} disabled={probarPosts.length} label={<Lang props={"Nombre de la página"} />} placeholder={"Pj: El mundo"} value={postData.title} onChange={(e) => setPostData({ ...postData, title: e.target.value })} />
                                    <TextField className={classes.form_rss} disabled={probarPosts.length} label={<Lang props={"Enlace a feed RSS"} />} value={postData.value} placeholder={"Pj: https://e00-elmundo.uecdn.es/elmundo/rss/portada.xml"} onChange={(e) => setPostData({ ...postData, value: e.target.value })} />
                                    <Select
                                        placeholder={postData.lang !== "" ? postData.lang : "Idioma"}
                                        className={classes.form_lang}
                                        value={postData.lang}
                                        options={[
                                            { value: 'ES', label: 'Español' },
                                            { value: 'EN', label: 'English' }]
                                        }
                                        onChange={handleLangSelect}
                                    />
                                    <ChipInput className={classes.form_tags} disabled={probarPosts.length} label={<Lang props={"Tags (enter para añadir)"} />} value={postData.tags} onChange={(chip) => setPostData({ ...postData, tags: [...postData.tags, chip] })} onAdd={(chip) => setPostData({ ...postData, tags: [...postData.tags, uploadReady(chip)] })} onDelete={(chip) => setPostData({ ...postData, tags: postData.tags.filter((tag) => tag !== chip) })} variant="outlined" />
                                </div>
                                <div className={classes.form_row}>
                                    {
                                        !probarPosts.length ?
                                            <div>
                                            </div>
                                            : <div>
                                                <h2><Lang props={"Noticias recientes de este enlace:"} /></h2>
                                                {probarPosts.slice(0, 5).map(item => {
                                                    return (
                                                        <Paper className={classes.rss_paper}>
                                                            <span>{item}</span>
                                                        </Paper>)
                                                })}
                                            </div>
                                    }
                                    {scores?.myScores?.userStatus > 0 && user ?
                                        <Button onClick={() => toggleAnadir()}>{anadir ? <Lang props={"Volver"} /> : <Lang props={"Crear carta"} />} </Button>
                                        :
                                        <div className={classes.locked_anadir}>
                                            <Button onClick={notify}>{anadir ? <Lang props={"Volver"} /> : <Lang props={"Crear carta"} />} </Button>
                                            <LockIcon />
                                        </div>}
                                </div>
                            </Paper>
                            {ayuda &&
                                <Paper elevation={6}>
                                    <span className={classes.span}>
                                        <h2><Lang props={"¡Bienvenido a la sindicación de contenidos!"} /></h2>
                                        <Paper className={classes.paper}>
                                            <p>
                                                <Lang props={"Cómo en encontrar un link para crear una tarjeta:"} />
                                            </p>
                                            <div className={classes.root}>
                                                <Paper position="static">
                                                    <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                                                        <Tab label="1" {...a11yProps(0)} />
                                                        <Tab label="2" {...a11yProps(1)} />
                                                        <Tab label="3" {...a11yProps(2)} />
                                                    </Tabs>
                                                </Paper>
                                                <TabPanel value={value} index={0}>
                                                    <p> <Lang props={"Busca el RRS de tu página"} /></p>
                                                    <div className={classes.imgcontainer}>
                                                        <img src={rss1} className={classes.img1} />
                                                    </div>
                                                </TabPanel>
                                                <TabPanel value={value} index={1}>
                                                    <p> <Lang props={"Elige categoría (si las hay)"} /></p>
                                                    <div className={classes.imgcontainer}>
                                                        <img src={rss2} className={classes.img2} />
                                                    </div>

                                                </TabPanel>
                                                <TabPanel value={value} index={2}>
                                                    <p> <Lang props={"Copia el link de la página que encuentres y pégalo en tu lista"} /></p>
                                                    <div className={classes.imgcontainer}>
                                                        <img src={rss3} className={classes.img3} />
                                                    </div>
                                                </TabPanel>
                                            </div>
                                        </Paper>
                                    </span>
                                </Paper>
                            }

                        </form>
                    </div>
                }
                {
                    posts.posts.length && !anadir ?

                        (
                            <div className={classes.paper_container}>
                                {posts.posts.map((item, key) => {
                                    return (
                                        <Animate
                                            duration={0.15}
                                            play={showPost === item._id} // Toggle when animation should start
                                            start={{
                                                transform: "translateX(0px)", opacity: 1
                                            }}
                                            end={{ transform: "translateX(40px)", opacity: 0.1 }}
                                        >
                                            <Paper className={classes.rss_paper} key={key} elevation={6}>
                                                {openRss === key ?
                                                    <>
                                                        <div className={classes.post_row}>
                                                            {user ?
                                                                <>
                                                                    {!item.users.find(element => element.userId === userId) ?
                                                                        <Button onClick={() => anadirPost(item._id, item.users)} className={classes.add_button_container}><RadioButtonUncheckedIcon className={classes.add} /></Button>
                                                                        :
                                                                        <Button onClick={() => anadirPost(item._id, item.users)} className={classes.add_button_container}><CheckCircleOutlineIcon className={classes.add} /></Button>}
                                                                </>
                                                                : <Button component={Link} to="/auth" className={classes.add_button_container}><RadioButtonUncheckedIcon className={classes.add} /></Button>}
                                                            <Button onClick={() => toggleOpenRss(key)}><h2 className={classes.post_title}>{item.title}</h2></Button>
                                                            <Button href={item.value} target="_blank"><VisibilityIcon /></Button>
                                                        </div>
                                                        <div className={classes.post_new_row}>
                                                            <span className={classes.post_new_tag}>{item.tags.length}<LocalOfferIcon className={classes.tag_icon} /><div className={classes.post_new_tag_content}>{item.tags.map(tag => { return (<button className={classes.post_tag_button}>{tag}</button>) })}</div></span>
                                                        </div>
                                                        <div className={classes.post_row}>
                                                            <p className={classes.post_users}>{item.users.length}<PeopleIcon className={classes.people_icon} /><img src={item.lang === "ES" ? ES : EN} className={classes.lang_icon} /><div className={classes.post_new_users_content}>{item.users.map(user => { return (<button className={classes.post_users_button}>{user.userName}</button>) })}</div></p>
                                                        </div>
                                                        <div className={classes.post_news_row}>
                                                            <h2><Lang props={"Últimas noticias subidas:"} /></h2>
                                                            {

                                                                !probando ?
                                                                    probarPosts.slice(0, 5).map(item => {
                                                                        return (
                                                                            <Paper className={classes.example_news} elevation={3}>
                                                                                <span>{item}</span>
                                                                            </Paper>)
                                                                    })
                                                                    :
                                                                    <CircularProgress />
                                                            }
                                                        </div>
                                                    </>
                                                    :
                                                    <>
                                                        <div className={classes.post_row}>
                                                            {user ?
                                                                <>
                                                                    {!item.users.find(element => element.userId === userId) ?
                                                                        <Button onClick={() => anadirPost(item._id, item.users)} className={classes.add_button_container}><RadioButtonUncheckedIcon className={classes.add} /></Button>
                                                                        :
                                                                        <Button onClick={() => anadirPost(item._id, item.users)} className={classes.add_button_container}><CheckCircleOutlineIcon className={classes.add} /></Button>}
                                                                </>
                                                                : <Button component={Link} to="/auth" className={classes.add_button_container}><RadioButtonUncheckedIcon className={classes.add} /></Button>}
                                                            <Button onClick={() => toggleOpenRss(key, item.value)}><h2 className={classes.post_title}>{item.title}</h2></Button>
                                                        </div>
                                                        <span className={classes.post_tag}>{item.tags.length}<LocalOfferIcon className={classes.tag_icon} /><div className={classes.post_tag_content}>{item.tags.map(tag => { return (<button className={classes.post_tag_button}>{tag}</button>) })}</div></span>
                                                        <div className={classes.post_row}>
                                                            <p className={classes.post_users}>{item.users.length}<PeopleIcon className={classes.people_icon} /><img src={item.lang === "ES" ? ES : EN} className={classes.lang_icon} /><div className={classes.post_users_content}>{item.users.map(user => { return (<button className={classes.post_users_button}>{user.userName}</button>) })}</div></p>
                                                        </div>
                                                    </>
                                                }
                                            </Paper>
                                        </Animate>)
                                })}
                            </div>
                        )
                        :
                        <div>
                            {!anadir && <h2><Lang props={"Ninguno coincide!"} /></h2>}

                        </div>
                }
            </div>
        )
    }
}

export default Lista
